/**
 * Widget-facing conversation Effect Schema conversions.
 *
 * Re-exports the zod schemas (single source of truth) from
 * `./widget-conversation-stream.ts` and provides Effect Schema conversions
 * for use in RPC endpoint definitions.
 */
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  widgetConversationListItemSchema,
  widgetConversationResponseSchema,
  widgetMessageSchema,
} from "./widget-conversation-stream";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type {
  WidgetConversationListItem,
  WidgetConversationResponse,
  WidgetMessage,
} from "./widget-conversation-stream";

import { zodToEffectSchema } from "@redotech/effect-api-shared-common/zod";
import {
  widgetConversationListItemSchema,
  widgetConversationResponseSchema,
} from "./widget-conversation-stream";

export const WidgetConversationResponseEffectSchema = zodToEffectSchema(
  widgetConversationResponseSchema,
);

export const WidgetConversationListItemEffectSchema = zodToEffectSchema(
  widgetConversationListItemSchema,
);
